// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-parameters
export const parseJson = <T = any>(
  value: string | undefined | null
): T | undefined => {
  try {
    return value ? (JSON.parse(value) as T) : undefined;
  } catch {
    return undefined;
  }
};

export function stringToHash(input: string, max = 10): number {
  let hash = 0;

  if (input.length === 0) return hash;

  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    hash = (hash << 5) - hash + c;
    hash = hash & hash;
  }

  return Math.abs(hash) % max;
}

export function base64UrlEncode(str?: string) {
  if (!str) {
    return '';
  }

  const encoded = btoa(str); // Standard Base64 encoding
  return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // URL-safe
}

export function base64UrlDecode(base64Url?: string) {
  if (!base64Url) {
    return '';
  }

  let padded = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert back
  while (padded.length % 4) padded += '='; // Restore padding if needed
  return atob(padded); // Decode
}

export type Stringifyable =
  | string
  | number
  | boolean
  | null
  | undefined
  | Stringifyable[]
  | { [key: string]: Stringifyable };
